// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { AbstractQueryParams, TypesaurusCoreDoc } from '@res/ngg-core';
import { IssueModel, IssueRef, IssueUpdateData } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace IssueActions {
  export class GetAllIssue {
    static readonly type = '[Issue] GetAllIssue';
    readonly type = GetAllIssue.type;
  }

  export class InitIssues {
    static readonly type = '[Issue] InitIssues';
    constructor(public id?: string) {}
  }

  export class CloseIssuesConnection {
    static readonly type = '[Issue] CloseIssuesConnection';
    readonly type = CloseIssuesConnection.type;
  }

  export class GetIssueById {
    static readonly type = '[Issue] GetIssueById';
    readonly type = GetIssueById.type;
  }

  export class UpdateIssue {
    static readonly type = '[Issue] UpdateIssue';
    constructor(
      public issueData: Partial<IssueUpdateData>,
      public ref: IssueRef,
    ) {}
  }

  export class UpdateIssueResult {
    static readonly type = '[Issue] UpdateIssueResult';
    constructor(public data: Array<TypesaurusCoreDoc<IssueModel> | null | undefined>) {}
  }

  export class DeleteIssue {
    static readonly type = '[Issue] DeleteIssue';
    readonly type = DeleteIssue.type;
  }

  export class QueryIssue {
    static readonly type = '[Issue] QueryIssue';

    constructor(
      public filter: {
        query: AbstractQueryParams<IssueModel>[];
      },
    ) {}
  }

  export class IssueError {
    static readonly type = '[Issue] IssueError';

    constructor(public error: Error) {}
  }
}
